import {
    IsBoolean,
    IsInt,
    IsObject,
    IsOptional,
    IsString,
    Max,
    Min
} from "class-validator";
import { Type } from "class-transformer";
import {
    CreateGameInDTO as BaseCreateGameInDTO,
    StartGameInDTO as BaseStartGameInDTO,
    ProcessActionInDTO as BaseProcessActionInDTO,
    ProcessActionOutDTO as BaseProcessActionOutDTO,
    GameSessionChallengeDTO as BaseGameSessionChallengeDTO,
    GetNextChallengeOutDTO as BaseGetNextChallengeOutDTO,
    GetNextChallengeInDTO as BaseGetNextChallengeInDTO,
    GameSessionResultDTO as BaseGameSessionResultDTO,
    GameSessionChallengeResultDTO as BaseGameSessionChallengeResultDTO
} from "../../types"

export class CreateGameInCharacterDTO {
    @IsString()
    symbol: string;

    /**
     * Опционально, можно будет прослушать произношение
     */
    @IsOptional()
    @IsString()
    pinyin?: string;

    /**
     * Перевод иероглифа
     */
    @IsOptional()
    @IsString()
    description?: string;

    /**
     * Индексы графем
     */
    @IsOptional()
    @Type(() => Number)
    graphemeIndexes?: number[];
}

export type CreateGameInMode = 'first' | 'last' | 'first_and_last';

export class CreateGameConfigDTO extends BaseCreateGameInDTO {
    /**
     * Если не указано, то будет рандомиться
     */
    @IsOptional()
    @Type(() => CreateGameInCharacterDTO)
    characters?: CreateGameInCharacterDTO[];

    @IsString()
    mode: CreateGameInMode = 'first_and_last';

    @IsBoolean()
    shuffle: boolean = false;

    @IsBoolean()
    playPinyin: boolean = false;

    @IsBoolean()
    showGrapheme: boolean = false;
}

export class CreateGameInDTO extends BaseCreateGameInDTO {
    config: CreateGameConfigDTO
}

export type ProcessActionType = 'done' | 'mistake' | 'hint';

export class StartGameInDTO extends BaseStartGameInDTO {}
export class ProcessActionInDTO extends BaseProcessActionInDTO {
    @IsObject()
    action: {
        type: ProcessActionType,
        data: {
            challengeId: string
        }
    };
}

export class GameSessionChallengeStateDTO {
    completed: boolean
}

export class GameSessionChallengeDTO extends BaseGameSessionChallengeDTO {
    symbol: string;
    graphical: {
        strokes: string[];
        medians: [number, number][][]
    }
    description?: string;
    pinyin?: string;
    graphemeStrokes: number[];
    state: GameSessionChallengeStateDTO = { completed: false }
}

export class ProcessActionOutDTO extends BaseProcessActionOutDTO {
    nextChallenge?: GameSessionChallengeDTO;
    state: GameSessionChallengeStateDTO = { completed: false };
}


export class NextChallengeOutDTO extends BaseGetNextChallengeOutDTO {
    nextChallenge?: GameSessionChallengeDTO;
    state: GameSessionChallengeStateDTO = { completed: false };
}

export class NextChallengeInDTO extends BaseGetNextChallengeInDTO {
    nextChallenge?: GameSessionChallengeDTO;
}

export class GameSessionChallengeResultDTO extends BaseGameSessionChallengeResultDTO {
    data: {
        symbol: string;
        graphical: {
            strokes: string[],
            medians: [number, number][][],
        },
        graphemeIndexes: number[],
    }
}

export class GameSessionResultDTO extends BaseGameSessionResultDTO {
    challenges: GameSessionChallengeResultDTO[];
}
